var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"line-hori-underline"},[_vm._t("default"),_c('span',{staticClass:"text-green"},[_c('sprite',{attrs:{"id":"line-horizontal-xlarge"}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }